type CharSetType = 'a' | 'n' | 'an';

function randomString(len: number, an: CharSetType = 'an'): string {
    if (typeof len !== 'number' || len <= 0) {
        throw new Error('Length must be a positive number');
    }

    const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const numeric = '0123456789';

    let chars: string;

    switch (an) {
        case 'a':
            chars = alpha;
            break;
        case 'n':
            chars = numeric;
            break;
        default:
            chars = alpha + numeric;
    }

    let result = '';
    const maxIndex = chars.length;

    for (let i = 0; i < len; i++) {
        const randomIndex = Math.floor(Math.random() * maxIndex);
        result += chars[randomIndex];
    }

    return result;
}

// ----------------------------------------------------------------------------

export default randomString;
